import React from 'react';
import { Lang, LANGUAGES, saveLang, t } from '../i18n';

interface Props {
  lang:         Lang;
  onLangChange: (lang: Lang) => void;
  onNewProject:  () => void;
  onLoadProject: () => void;
  onLogout:      () => void;
}

const StartupScreen: React.FC<Props> = ({ lang, onLangChange, onNewProject, onLoadProject, onLogout }) => {
  const tr = t(lang);

  const handleLang = (code: Lang) => {
    saveLang(code);
    onLangChange(code);
  };

  return (
    <div className="startup-overlay">
      <div className="startup-dialog">

        <div className="startup-left">
          <div className="startup-title" style={{ textAlign: 'center' }}>{tr.startupTitle}</div>

          <button className="startup-btn" onClick={onNewProject}>
            {tr.startupNewProject}
          </button>
          <button className="startup-btn" onClick={onLoadProject}>
            {tr.startupLoad}
          </button>

          <button className="startup-btn startup-btn-logout" onClick={onLogout}>
            {tr.startupLogout}
          </button>

          {/* Przełącznik języka – poniżej przycisku Logout, wyśrodkowany */}
          <div className="lang-switcher lang-switcher-startup">
            {LANGUAGES.map(l => (
              <button
                key={l.code}
                className={`lang-btn${lang === l.code ? ' lang-btn-active' : ''}`}
                onClick={() => handleLang(l.code)}
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>

        <div className="startup-right">
          <img src={process.env.PUBLIC_URL + '/logo.png'} alt="PDD logo" className="startup-logo" />
        </div>

      </div>
    </div>
  );
};

export default StartupScreen;
